module.exports = __webpack_public_path__ + "img/television.8b70a601.svg";